import React from 'react'
import { useField } from 'formik'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

const IpsaSelectField = ({ values, placeholder, label, informationText, ...props }) => {
    const [field, meta] = useField(props)
    const { touched, error } = meta
    const { onChange, onBlur, value } = field

    return (
        <>
            <div style={{ minWidth: '15px' }}>
                {informationText && <FontAwesomeIcon icon={faInfoCircle} title={informationText} />}
            </div>
            <div
                style={{
                    flexGrow: '1',
                }}
            >
                <select
                    className={error && touched ? 'error-field move-label' : 'move-label'}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    name={field.name}
                >
                    {placeholder && (
                        <option disabled value="">
                            {placeholder}
                        </option>
                    )}
                    {values.map((item) => {
                        return (
                            <option key={item} value={item}>
                                {item}
                            </option>
                        )
                    })}
                </select>
                {(label || placeholder) && (
                    <label className={error && touched ? 'error' : ''}>
                        {label || placeholder}
                    </label>
                )}
            </div>
            {/* {touched && error ? <div className="error">{error}</div> : null} */}
        </>
    )
}

export default IpsaSelectField
